import { render, staticRenderFns } from "./AudioRoom.vue?vue&type=template&id=1460c30e"
import script from "./AudioRoom.vue?vue&type=script&lang=js"
export * from "./AudioRoom.vue?vue&type=script&lang=js"
import style0 from "./AudioRoom.vue?vue&type=style&index=0&id=1460c30e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports